<template>
  <div>
    <div class="mb-2" v-for="field in fields" :key="field.identifier">
      <div class="text-xs text-gray-400 leading-snug">{{ field.name }}</div>
      <div v-if="field.identifier == 'email'">
        <a :href="`mailto:${person.email}`" class="text-gray-900 hover:underline">{{ person.email }}</a>
      </div>
      <div v-else>{{ person[field.identifier] }}</div>
    </div>
    <div v-if="fields.length == 0" class="my-2 text-gray-500">
      Geen contactgegevens
    </div>
  </div>
</template>

<script>
// import { mapObjectsById } from "@/functions.js";

const DONT_INCLUDE = ["name", "job_title"];

export default {
  props: {
    person: Object
  },

  computed: {
    fields() {
      return this.$store.getters.personFields
        .filter(f => !DONT_INCLUDE.includes(f.identifier))
        .filter(f => this.person[f.identifier]);
    },

    customfields() {
      return [];

      // let map = mapObjectsById(this.person.customfields);

      // return this.$store.getters.personCustomfields.map(customfield => {
      //   return {
      //     ...customfield,
      //     value: map[customfield.id] ? map[customfield.id].value : null
      //   };
      // });
    }
  }
};
</script>
